/**
 * @fileoverview Toggle Component
 * @author Matt Convente (mconvente@yext.com)
 */
goog.declareModuleId('yext.ui.components.toggle');

import * as styles from '/ui/components/toggle/toggle.module.scss';

/**
 * @param {{checked: boolean,
 *          disabled?: boolean,
 *          id?: string,
 *          name?: string,
 *          onBlur?: (function(?): void),
 *          onChange: (function(?): void),
 *          onFocus?: (function(?): void),
 *          pendoId?: string,
 *          tid?: string,
 *          value: (boolean|string),
 *        }} props
 * @return {React.ReactElement}
 */
export function Toggle({
  checked = false,
  disabled = false,
  id = '',
  name = id,
  onBlur,
  onChange,
  onFocus,
  pendoId,
  tid,
  value,
}) {
  return (
    <label className={`${styles.toggle}`} tid={tid}>
      <input
        checked={checked}
        className={`${styles.input}`}
        disabled={disabled}
        id={id}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        type="checkbox"
        value={value}
        data-pendo={pendoId}
      />
      <div className={`${styles.wrapper}`}>
        <div className={`${styles.knob}`}></div>
        <div className={`${styles.rail}`}></div>
      </div>
    </label>
  );
}
